import { FieldControl } from '@signature-it/ngx-generic/enums';
import {SelectField} from "./select";

export class FlatSelectField extends SelectField {
    controlType = FieldControl.FLAT_SELECT;
	withHoverImages: boolean;
    imageOnClick: boolean;
	imgAndTextOnly: boolean = false;
    template: string;
	constructor(options: {} = {}) {
		super(options);
		this.controlType = FieldControl.FLAT_SELECT;
        this.template = options['ngxComponentHtml'] || "";
        switch(options['controlType']) {
            case FieldControl.FLAT_SELECT_IMG_AND_TEXT_ONLY: {
                this.imgAndTextOnly = true;
                this.withHoverImages =  false;
                break;
            }
            case FieldControl.FLAT_SELECT_IMAGE_ON_CLICK: {
                this.imageOnClick = true;
                this.withHoverImages =  false;
                break;
            }
            default: {
                this.withHoverImages = options['withHoverImages'] || false;
                break;
            }
        }
	}
}
